import { cn } from "../lib/cn";

type LineOrientation = "horizontal" | "vertical";
type LineVariant = "solid" | "dashed";

export type LineProps = {
    className?: string;
    orientation?: LineOrientation;
    variant?: LineVariant;
};

export function Line({
    className,
    orientation = "horizontal",
    variant = "solid",
}: LineProps) {
    if (variant === "dashed") {
        const isVertical = orientation === "vertical";

        return (
            <div
                className={cn(
                    "flex bg-border-strong",
                    "[-webkit-mask-position:center] [-webkit-mask-repeat:repeat] [mask-position:center] [mask-repeat:repeat]",
                    isVertical ? "h-full w-px" : "h-px w-full",
                    className,
                )}
                style={{
                    maskImage: isVertical
                        ? dashedLineMaskVertical
                        : dashedLineMaskHorizontal,
                    WebkitMaskImage: isVertical
                        ? dashedLineMaskVertical
                        : dashedLineMaskHorizontal,
                }}
            />
        );
    }

    if (orientation === "vertical") {
        return (
            <div
                className={cn(
                    "flex h-full border-border-strong border-l border-solid",
                    className,
                )}
            />
        );
    }

    return (
        <div
            className={cn(
                "flex w-full border-border-strong border-t border-solid",
                className,
            )}
        />
    );
}

const dashedLineMaskHorizontal =
    "url(\"data:image/svg+xml,%3csvg width='4' height='1' viewBox='0 0 4 1' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='2' height='1' fill='%2330303A'/%3e%3c/svg%3e\")";

const dashedLineMaskVertical =
    "url(\"data:image/svg+xml,%3csvg width='1' height='4' viewBox='0 0 1 4' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='1' height='2' fill='%2330303A'/%3e%3c/svg%3e\")";
